<template>
  <div class="Piofooter">
    <div class="footercontainer">
      <div class="copyright">
        <div class="footercolC" style="font-size:14px">
          <ul>
            <li>
              <span
                >Copyright◎
                <a href="http://www.pioneertools.com" class="corpname"
                  >缙云县先锋工具有限公司</a
                >
                版权所有</span
              >
            </li>
            <li>
              <span class="corpname">
                <a
                  target="_blank"
                  href="http://idinfo.zjamr.zj.gov.cn/bscx.do?method=lzxx&id=3325263325260060025833"
                >
                  <img
                    src="http://idinfo.zjamr.zj.gov.cn/image/i_lo2.gif"
                    style="width:22px"
                  />
                </a>
                <a target="_blank" href="http://www.beian.miit.gov.cn/">
                  浙ICP备19040256号
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.footercolC li {
  padding: 3px 0;
}
.corpname {
  color: #fff;
  transition: all 0.4s ease-in;
  font-size: 16px;
  padding: 0 5px;
}
.corpname:hover {
  color: cadetblue;
}
.z-100 {
  width: 100% !important;
}
.Piofooter {
  position: static;
  bottom: auto;
  height: 80px;
  left: 0;
  width: 100%;
  background: #666;
}
.copyright {
  text-align: center;
  color: aliceblue;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.copyright span p {
  text-align: center;
  color: aliceblue;
  font-size: 12px;
}
/* .footercol{
        width: 20%;
        background-color: rgb(83, 8, 8);
        float: left;
        height: 100px;
        text-align: center
    } */
.footercolC {
  /* background-color: rgb(83, 8, 85); */
  /* float: left; */
  text-align: center;
  height: 80px;
  font-size: 14px;
  padding: 10px 0;
}
.footercolC span {
  font-size: 15px;
}

.footercontainer {
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 802px) {
  .footercontainer {
    max-width: 450px;
  }
}
</style>

<script>
export default {
  name: "Piofooter",
};
</script>
